import * as React from 'react';

import BreadcrumbsModule from 'bundles/unified-description-page-common/components/modules/breadcrumbs/BreadcrumbsModule';
import ConsumerBreadcrumbs from 'bundles/unified-description-page-common/components/modules/breadcrumbs/ConsumerBreadcrumbs';
import SaveButton from 'bundles/unified-description-page-common/components/modules/breadcrumbs/SaveButton';
import { useCourseraPlusOwnership } from 'bundles/unified-description-page-common/contexts/consumer/CourseraPlusOwnershipContext';
import { useSavedProduct } from 'bundles/unified-description-page-common/contexts/consumer/CourseraPlusSavedProductContext';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

type Props = {
  pageData: ConsumerSpecializationPageFieldsFragment | ConsumerCoursePageFieldsFragment;
  config?: {
    removeLinksAboveFold?: boolean;
    hideCtas?: boolean;
  };
};
const ConsumerBreadcrumbsModuleRenderer = ({ pageData, config }: Props) => {
  const courseraPlusOwnership = useCourseraPlusOwnership();
  const savedProduct = useSavedProduct();

  return (
    <BreadcrumbsModule
      pageData={pageData}
      breadcrumbs={!config?.removeLinksAboveFold ? <ConsumerBreadcrumbs domains={pageData.domains} /> : undefined}
      ctas={
        !config?.hideCtas &&
        courseraPlusOwnership?.isSubscribedToCPlusOrLite &&
        savedProduct?.saveProductManager &&
        !savedProduct?.isSavedLoading
          ? [
              <SaveButton
                key="save-button"
                isWishlisted={savedProduct.isSaved}
                productId={pageData.id}
                saveProductManager={savedProduct.saveProductManager}
              />,
            ]
          : undefined
      }
    />
  );
};

export default ConsumerBreadcrumbsModuleRenderer;
